// ----------------------------------------------------------------------

export function path(root: string, link: string) {
  return `${root}${link}`;
}

export const ROOTS_DASHBOARD = '/';
export const ROOTS_AUTH = '/';
export const ROOT_CUSTOMER = '/customer';
export const ROOT_USER = '/user';
export const ROOT_OWNER = '/owner';
export const ROOT_COMPANY = '/company';
export const ROOT_BOOST = '/boost';
export const ROOT_BOOST_GROUP = '/bg';
export const ROOT_GRID = '/grid';
export const ROOT_NETWORK = '/network';
export const ROOT_SITE = '/site/energy';
export const ROOT_ENERGY_TREND = '/energy/trend';
export const ROOT_FLEET_MANAGEMENT = '/rfid';

// ----------------------------------------------------------------------

export const PATH_AUTH = {
  root: ROOTS_AUTH,
  register: path(ROOTS_AUTH, '/register'),
  activate: path(ROOTS_AUTH, '/activate/:token'),
  verify: path(ROOTS_AUTH, '/verify')
};

export const PATH_PAGE = {
  comingSoon: '/coming-soon',
  maintenance: '/maintenance',
  pricing: '/pricing',
  payment: '/payment',
  about: '/about-us',
  contact: '/contact-us',
  faqs: '/faqs',
  page404: '/404',
  page500: '/500',
  components: '/components'
};

export const PATH_DASHBOARD = {
  root: ROOTS_DASHBOARD,
  customer: {
    root: path(ROOTS_DASHBOARD, ROOT_CUSTOMER),
    users: path(ROOT_CUSTOMER, ROOT_USER),
    owners: path(ROOT_CUSTOMER, ROOT_OWNER),
    newUser: path(ROOT_CUSTOMER, `${ROOT_USER}/new`),
    editUser: path(ROOT_CUSTOMER, `${ROOT_USER}/edit`),
    newOwner: path(ROOT_CUSTOMER, `${ROOT_OWNER}/new`),
    editOwner: path(ROOT_CUSTOMER, `${ROOT_OWNER}/edit`),
    boostGroup: {
      list: path(ROOT_CUSTOMER, `${ROOT_OWNER}/bg/list`),
      unassigned: path(ROOT_CUSTOMER, `${ROOT_OWNER}/bg/list/unassigned`),
      config: path(ROOT_CUSTOMER, `${ROOT_OWNER}/bg/config`)
    },
    account: path(ROOT_CUSTOMER, `/account`)
  },
  boost: {
    root: path(ROOTS_DASHBOARD, ROOT_BOOST),
    add: path(ROOT_BOOST, `/add`),
    edit: path(ROOT_BOOST, `/edit`)
  },
  boostGroup: {
    root: path(ROOTS_DASHBOARD, ROOT_BOOST_GROUP),
    list: path(ROOT_BOOST_GROUP, `/list`),
    edit: path(ROOT_BOOST_GROUP, `/edit`),
    add: path(ROOT_BOOST_GROUP, `/add`),
    config: path(ROOT_BOOST_GROUP, `/config`),
    report: path(ROOT_BOOST_GROUP, '/report'),
    reportAdmin: path(ROOT_BOOST_GROUP, '/report/admin')
  },
  network: {
    root: path(ROOTS_DASHBOARD, ROOT_NETWORK),
    dashboard: path(ROOT_NETWORK, `/dashboard`),
    ocpi: {
      cpo: path(ROOT_NETWORK, `/ocpi/cpo`),
      cpoAdd: path(ROOT_NETWORK, `/ocpi/cpo/add`),
      cpoEdit: path(ROOT_NETWORK, `/ocpi/cpo/:cpoId/edit`),
      emsp: path(ROOT_NETWORK, `/ocpi/cpo/:cpoId/emsp`),
      emspAdd: path(ROOT_NETWORK, `/ocpi/cpo/:cpoId/emsp/add`),
      emspEdit: path(ROOT_NETWORK, `/ocpi/cpo/:cpoId/emsp/:emspId/edit`)
    },
    roaming: path(ROOT_NETWORK, `/roaming/config`),
    chargePoints: path(ROOT_NETWORK, `/cp/management`)
  },
  siteEnergy: {
    root: path(ROOTS_DASHBOARD, ROOT_SITE),
    dashboard: path(ROOT_SITE, `/dashboard`),
    settings: path(ROOT_SITE, `/settings`),
    report: path(ROOT_SITE, `/reports`),
    management: path(ROOT_SITE, `/management`)
  },
  grid: {
    root: path(ROOTS_DASHBOARD, ROOT_GRID),
    dashboard: path(ROOT_GRID, `/dashboard`),
    openADR: path(ROOT_GRID, `/oadr`),
    openADRForm: path(ROOT_GRID, `/oadr-submit`)
  },
  energy: {
    root: path(ROOTS_DASHBOARD, ROOT_ENERGY_TREND),
    forecast: path(ROOT_ENERGY_TREND, `/forecast`),
    portfolio: path(ROOT_ENERGY_TREND, `/portfolio`)
  },
  fleetManagement: {
    root: path(ROOTS_DASHBOARD, ROOT_FLEET_MANAGEMENT),
    list: path(ROOT_FLEET_MANAGEMENT, `/list`),
    add: path(ROOT_FLEET_MANAGEMENT, `/add`),
    edit: path(ROOT_FLEET_MANAGEMENT, `/:rfid/edit`),
    upload: path(ROOT_FLEET_MANAGEMENT, `/upload`)
  }
};

export const PATH_DOCS = 'https://freewiretech.atlassian.net/wiki/spaces/AMPDOCS/overview';
